// Settings > Connections > Remove: the confirm text, built from GET /api/config/transports/<id>/usage.
// No imports, so the frontend tests can compile it.

export interface TransportUsage {
  transport: string;
  label: string;
  packets: number;
  node_sightings: number;
  stats: number;
  total: number;
}

export const REMOVE_CONNECTION_BUTTON = "Remove And Delete Data";

function n0(v: number): string {
  return v.toLocaleString("en-US");
}

function count(n: number, one: string, many: string): string {
  return `${n0(n)} ${n === 1 ? one : many}`;
}

// "Remove AIDA MeshCore? This deletes 48,210 packets, 1,203 node sightings and its stats. Nodes heard only through it stay as nodes."
// With nothing stored: "Remove AIDA MeshCore? It has not stored anything yet."
export function removeConnectionMessage(
  name: string,
  u: Pick<TransportUsage, "packets" | "node_sightings"> & { stats?: number },
): string {
  if (u.packets + u.node_sightings + (u.stats ?? 0) === 0) return `Remove ${name}? It has not stored anything yet.`;
  return (
    `Remove ${name}? This deletes ${count(u.packets, "packet", "packets")}, ${count(u.node_sightings, "node sighting", "node sightings")} and its stats. ` +
    "Nodes heard only through it stay as nodes."
  );
}
